import { render, staticRenderFns } from "./ClinicalHistoryTemplateConfig.vue?vue&type=template&id=68cb2de3&scoped=true"
import script from "./ClinicalHistoryTemplateConfig.vue?vue&type=script&lang=js"
export * from "./ClinicalHistoryTemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./ClinicalHistoryTemplateConfig.vue?vue&type=style&index=0&id=68cb2de3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb2de3",
  null
  
)

export default component.exports